import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DirectionKindEnum } from '@zaoblako/shared/modules/catalog/enums/direction.kind.enum';

/**
 * Localized human-readable string representations of {@link DirectionKindEnum} enumeration values
 */
export const DirectionKindEnumI18n: Record<I18nLocalesEnum, Record<DirectionKindEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [DirectionKindEnum.OPERATING_INCOME]: 'Доходы.Операционные',
    [DirectionKindEnum.OTHER_INCOME]: 'Доходы.Прочие',
    [DirectionKindEnum.OPERATING_EXPENSE]: 'Расходы.Производственные',
    [DirectionKindEnum.COMMERCIAL_EXPENSE]: 'Расходы.Коммерческие',
    [DirectionKindEnum.OTHER_EXPENSE]: 'Расходы.Прочие',
    [DirectionKindEnum.FINANCIAL_ACTIVITY]: 'Финансовая деятельность',
    [DirectionKindEnum.TECHNICAL_OPERATIONS]: 'Технические операции',
  },
  [I18nLocalesEnum.EN_US]: {
    [DirectionKindEnum.OPERATING_INCOME]: 'Operating incomes',
    [DirectionKindEnum.OTHER_INCOME]: 'Other incomes',
    [DirectionKindEnum.OPERATING_EXPENSE]: 'Operating expenses',
    [DirectionKindEnum.COMMERCIAL_EXPENSE]: 'Commercial expenses',
    [DirectionKindEnum.OTHER_EXPENSE]: 'Other expenses',
    [DirectionKindEnum.FINANCIAL_ACTIVITY]: 'Financial activities',
    [DirectionKindEnum.TECHNICAL_OPERATIONS]: 'Technical operations',
  },
};
